/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import FormValidation from '../../atoms/formEnums/formValidation';
import InputText from '../../atoms/inputText/inputText';
import InputTag from '../../atoms/inputTag/inputTag';
import Label from '../../atoms/label/label';
import { IconType } from '../../atoms/icon/icon';
import Button, { ButtonTheme } from '../../atoms/button/button';
import './formYaml.scss';
import LoadFromCatalogButton from '../../molecules/loadFromCatalogButton/loadFromCatalogButton';
import { unset } from 'lodash';
import ExternalLink from '../../atoms/externalLink/externalLink';
import YamlEditor from '@focus-reactive/react-yaml';
import swal from 'sweetalert';


/**
 * Form Input Text is a basic HTML input field, label, error text and HelpButton.
 * It is designed to send the input value to a parent component, such as organisms Form,
 * and to shows the validation state of the field provided by the parent component.
 */
const FormYaml = (props) => {
  const {
    id,
    label,
    value,
    helpText

  } = props;

  const [yamlValue,setYamlValue]=useState(null);
  const childRef = useRef();
  const handlerCopyClipboard=()=>{
    copyTextToClipboard(yamlValue).then(()=>{
      swal('Copied!', 'The signaling is copied on your clipboard', 'success');
    });
  }
  useEffect(()=>{
    if(value)
      setYamlValue(value);
  },[value]);
  async function copyTextToClipboard(text) {
    if ('clipboard' in navigator) {
      let formattedString = yamlValue.replace(/\n/gm, "\n");
      return await navigator.clipboard.writeText(formattedString);
    } else {
      return document.execCommand('copy', true, text);
    }
  }
  const handleYamlTextChange=(e)=>{
    setYamlValue(e.json);
  }
  
  return (
    <div className={`form-group row`}>
      { label !== ''
        && (
          <Label helpText={helpText}>{label}</Label>
        )}
         <div className="form-json-value col-sm-12 form-yaml-copy"><Button 
              id={`button-copy`}
              theme={ButtonTheme.PRIMARY}
              onClick={handlerCopyClipboard}
            >
              Copy to clipboard
            </Button></div>  
      <div className="form-yaml-value col-sm-12">
        {value && <YamlEditor json={value} onChange={handleYamlTextChange} />}
      </div>
    </div>
  );
};

FormYaml.propTypes = {
  /**
   * id of input field
   */
  id: PropTypes.string,
  /**
   * Name of input attribute
   */
  label: PropTypes.string,
  /**
   * Input help text
   */
  helpText: PropTypes.string,
  /**
   * Initial input value
   */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

FormYaml.defaultProps = {
  id: '',
  label: '',
  helpText: '',
  value: '',
};

export default FormYaml;
